import { forwardRef } from 'react';
import { AlertProps } from '@mui/material';
import { SAlert } from './styled';

export const Alert = forwardRef<HTMLDivElement, AlertProps>(({ children, ...props }, ref) => {
  return (
    <SAlert ref={ref} {...props}>
      {children}
    </SAlert>
  );
});
